/* template */
<template><page><base-container><float-ball/><float-ball-slot/></base-container></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_ab489714"}'>
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_ab489714"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_ab489714"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_ab489714"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'float-ball':getComponent(require("./float-ball.mpx?isComponent&outputPath=components%2Ffloat-ball029a44da%2Findex")),'float-ball-slot':getComponent(require("./float-ball-slot.mpx?isComponent&outputPath=components%2Ffloat-ball-slot09b7fdbf%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>